import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ClimateResilienceRoleEnum } from "src/app/shared/generated/enum/climate-resilience-role-enum";
import { LTInfoRoleEnum } from "src/app/shared/generated/enum/l-t-info-role-enum";

/**
 * Gates routes that manage Climate Resilience goals/outcomes/indicators. Mirrors
 * legacy `ClimateResilienceManageAsAdminFeature` — admits LTInfo Admin OR
 * Climate Resilience Admin. Unauthorized access is redirected to the Data Center.
 */
@Injectable({ providedIn: "root" })
export class ClimateResilienceAdminAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const canManage = user?.ClimateResilienceRoleID === ClimateResilienceRoleEnum.Admin
                    || user?.LTInfoRoleID === LTInfoRoleEnum.Admin;
                if (!canManage) {
                    this.router.navigate(["/data-center"]);
                    return false;
                }
                return true;
            })
        );
    }
}
